/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { CreateContactMutationRequest, CreateContactMutationResponse, CreateContactHeaderParams, CreateContact401 } from "../../models/contactsController/CreateContact";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createContactMutationKey = () => [{ url: '/contacts' }] as const

export type CreateContactMutationKey = ReturnType<typeof createContactMutationKey>

/**
 * {@link /contacts}
 */
export async function createContact(data: CreateContactMutationRequest, headers?: CreateContactHeaderParams, config: Partial<RequestConfig<CreateContactMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateContactMutationResponse, ResponseErrorConfig<CreateContact401>, CreateContactMutationRequest>({ method : "POST", url : `/contacts`, data : requestData, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function createContactMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateContactMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createContactMutationKey()
        return mutationOptions<CreateContactMutationResponse, ResponseErrorConfig<CreateContact401>, {data: CreateContactMutationRequest, headers?: CreateContactHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, headers }) => {
            return createContact(data, headers, config)
          },
        })

}

/**
 * {@link /contacts}
 */
export function useCreateContact<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateContactMutationResponse, ResponseErrorConfig<CreateContact401>, {data: CreateContactMutationRequest, headers?: CreateContactHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateContactMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createContactMutationKey()

          const baseOptions = createContactMutationOptions(config) as UseMutationOptions<CreateContactMutationResponse, ResponseErrorConfig<CreateContact401>, {data: CreateContactMutationRequest, headers?: CreateContactHeaderParams}, TContext>
          

          return useMutation<CreateContactMutationResponse, ResponseErrorConfig<CreateContact401>, {data: CreateContactMutationRequest, headers?: CreateContactHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateContactMutationResponse, ResponseErrorConfig<CreateContact401>, {data: CreateContactMutationRequest, headers?: CreateContactHeaderParams}, TContext>
      
}